const PREFIX = 'cheddar-demo.lastWithdrawAddress.';

export function lastAddressKey(chain: string): string {
  return `${PREFIX}${chain.toUpperCase()}`;
}

export function loadLastWithdrawAddress(chain: string): string {
  try {
    return localStorage.getItem(lastAddressKey(chain)) ?? '';
  } catch {
    return '';
  }
}

export function saveLastWithdrawAddress(chain: string, address: string): void {
  try {
    localStorage.setItem(lastAddressKey(chain), address.trim());
  } catch {
    // ignore quota / private mode
  }
}

/** Epic opening cap values (whole dollars) — display only; server is authoritative. */
export const DISPLAY_CAP_PER_TX_USD = '25';
export const DISPLAY_CAP_ROLLING_24H_USD = '100';
